import { TOP_NAV_ITEMS } from '~utils/constants'

export const MENU_SUB_ITEMS = TOP_NAV_ITEMS.reduce(
  (prevValue, currentValue) => [
    ...prevValue,
    ...(currentValue?.subItems || []),
  ],
  []
)
